import { render, staticRenderFns } from "./ImportDot.vue?vue&type=template&id=5b5b776a&"
import script from "./ImportDot.vue?vue&type=script&lang=js&"
export * from "./ImportDot.vue?vue&type=script&lang=js&"
import style0 from "./ImportDot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports